import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { hasPermission } from '../utils/permissions';

const PermissionRoute = ({ permission, children }) => {
    const { user } = useContext(AuthContext);

    if (!user || !hasPermission(user.role, permission)) {
        return <Navigate to="/admin" replace />;
    }

    return children;
};

export default PermissionRoute;
